import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../../actions/application';
import { ImageButtonList } from '../../common/imageButtonList';
import ImageText from '../../common/imageText';
import './../styles.css';

class MusicImageButtonList extends ImageButtonList {
  render() {
    let classes = `image-button-list `;
    if (this.props.flexClass) {
      classes += this.props.flexClass;
    }
    let style = {
      top: this.props.top,
      left: this.props.left,
    };
    if (this.props.width) {
      style.width = this.props.width;
    }
    if (this.props.height) {
      style.height = this.props.height;
    }
    return (
      this.state.buttons && (
        <div>
          <div className='music-description'>
            <ImageText id="text" src={this.props.imageButtons[this.state.currentButton].desc} />
          </div>
          <div className={classes} style={style}>
            {this.state.buttons}
          </div>
        </div>
      )
    );
  }
}

export default connect(
  state => ({
    context: state.application.currentContext
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        ...applicationActions
      },
      dispatch
    )
  })
)(MusicImageButtonList);
